import {fetchRemote} from "../Api/api-util";

const validatedPermissionCache = {};

//MDB.Security is potentially not yet defined upon export
//Exporting a single object with getters should do the trick however
export default {
    Permissions: {
        //WorkLog = SprintFiltersManagement
        WorkLog: '5A199901-4381-4EFC-8EF1-7ABBEB402161',
        SettingsDivisionMiscellaneous: 'A1B9B2E3-4E3B-49FD-83A6-03EF3D19BF44',

        WidgetClickExecuteStoredProcedure: '7f914e33-76d0-4351-b0fe-276b2d31e5f1',
        DmVisualizer: '2E20167A-AE9C-4C16-BF03-C15145C24DED',
        Newsroom: '60FC553D-21EB-40AD-884D-C3CA9CDE8737',
        
        //Start PushNotifications
        PushNotificationsManage: '0548d310-fdec-4902-b0c4-349b98ff6e13',
        //End PushNotifications

        //Start SprintPlanning
        SprintPlanning: '5C1BEA33-67EE-40B1-BF58-FDBA10E7F7B6',
        SprintPlanningTimeTracking: '77d47ceb-b8ed-47df-9549-2f1079cb5f2b',
        SprintPlanningComments: '93ec6dbf-99e1-4bc8-b9de-228f78b4bcac',
        //End SprintPlanning

        //Start Journey Composer
        JourneyBuilder: 'c631638b-067a-42ed-b9a1-9e273aee0b45',
        //End Journey Composer

        //Start EMV
        MediaLibrary: '2de72a19-dadb-47f9-ae71-3e6c8225a859',
        EmvPrimaryTemplateBuilder: 'de07fdd1-fa0d-4b54-b5bb-3dd55de5ea15',
        EmvTemplateFiller: '880d398b-df30-43eb-b306-53a62732eea4',
        EmvCustomCss: '0e9614b2-5b9f-4cbf-9a61-cf9624b8cd3f',
        //End EMV

        //Start DPN
        DpnOfferSettingsViewInvalid: '0547E638-7930-4D57-9812-CB9C5C60363C',
        DpnOffersSettingsDelete: 'A5138E3D-E74A-4E9E-92ED-3C373F73B07D'
        //End DPN
    },
    PermissionGrantTypes: {
        Read: 1,
        Write: 2,
        Delete: 4,
        SeeInMenu: 8
    },
    validatePermission(permission, grantType) {
        //Base our cache key on the given permissionId
        let cacheKey = permission;

        if(grantType){
            if(Array.isArray(grantType)){
                //MVC requires a single number
                grantType = grantType.reduce((sum, cur) => sum + cur, 0);
            }

            //Include grantType in our cache key
            cacheKey = cacheKey + '|' + grantType;
        }

        if(validatedPermissionCache[cacheKey]){
            return validatedPermissionCache[cacheKey]
        }

        //We want to do the least possible processing prior to caching
        //Set our cacheKey asap
        return validatedPermissionCache[cacheKey] = new Promise((resolve, reject) => {
            fetchRemote(`/api/Users/ValidateRight?rightId=${permission}&grantType=${grantType}`)
                .then(
                    () => resolve(true),
                    () => reject(false)
                );
        });
    }
};